import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfPoint,
  PdfRect,
  PdfFont,
  PdfBrush,
  PdfColor,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutLabelTextGen } from '../layoutLabelText';
import { IItemCount } from '@educraft/base';
import { OptsLabelText } from '../optsLabelText';
import { GUtil } from '../../pdf/gutil';
import { calcOrigin } from '../../core/genHelper';
import { placeObjects } from '../../core/placeObjects';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/label';

/**
 * Vybarveni (Color Matching Exercise)
 *
 * Layout: Left side has questions with colored squares, right side has
 * randomly placed large answer numbers to color.
 *
 * Migrated from C# EduFrame.Single.Generators.Vybarveni
 */
export class Vybarveni implements ILayoutLabelTextGen, IItemCount {
  countDefault(): number {
    return 8;
  }
  countMin(): number {
    return 8;
  }
  countMax(): number {
    return 8;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const page = pdf.addPage();

    const margin = PdfUnit.FromMillimeters(5);
    const { origin, size } = calcOrigin(3, 1, margin, PdfSize.A4);
    const squareSize = PdfUnit.FromMillimeters(10);
    const itemSize = new PdfSize(PdfUnit.FromMillimeters(50), PdfUnit.FromMillimeters(40));

    const colors = GUtil.standardColors;
    const colorCount = Math.min(opts.list.length, colors.length);
    const items = opts.list.slice(0, colorCount);

    const s1 = size.height / colorCount;
    const sizeWidth = size.width - squareSize - margin;

    const questionTexts = items.map((item) => [item.label.getText() ?? '']);
    const answerTexts = items.map((item) => item.text);

    const f1 = page.adjustFontMulti(questionTexts, GUtil.baseFont, new PdfSize(sizeWidth, s1));
    const f2 = page.adjustFont(
      itemSize.width,
      answerTexts,
      new PdfFont(PdfFont.BOLD_FONT_NAME, 100)
    );

    const rightRect = new PdfRect(origin.x + size.width, origin.y, size.width * 2, size.height);

    const indices = Array.from({ length: colorCount }, (_, i) => i);
    const placed = placeObjects(opts.data.random, rightRect, itemSize, indices);

    for (let i = 0; i < colorCount; i++) {
      const r = new PdfRect(origin.x, origin.y + i * s1, sizeWidth, s1);
      const r1 = new PdfRect(r.right + margin, r.centerY - squareSize / 2, squareSize, squareSize);

      page.drawLabel(items[i].label, { rect: r, font: f1 });

      page.drawRectangle(null, colors[i], r1);
      page.drawRectangle(GUtil.basePen, null, r1);
    }

    for (const obj of placed) {
      page.drawString(items[obj.data].text, f2, null, GUtil.basePen, obj.rect, ETextAlign.Center);
    }
  }
}
